import Vuex from "vuex";

const baseUrl = process.env.VUE_APP_DOMAIN ?? "http://localhost:5001";
const aat = process.env.VUE_APP_ADMIN_ACCESS_TOKEN || "";
const useCredentials = process.env.VUE_APP_LOCAL_ONLY !== "true";

function getCookie() {
  return "";
}

async function handleResponse(res, json = true) {
  if (!res.ok) {
    const error = new Error(`HTTP error! status: ${res.status}`);
    error.status = res.status;
    throw error;
  }

  return json ? await res.json() : res;
}

async function getApiCall(hook, json = true) {
  const res = await fetch(`${baseUrl}${hook}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "admin-access-token": aat,
      "cn-token": getCookie("cn-token"),
    },
    credentials: useCredentials ? "include" : "omit",
  });

  return handleResponse(res, json);
}

async function postApiCall(hook, payload = {}, json = true, url = baseUrl) {
  try {
    const res = await fetch(`${url}${hook}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "admin-access-token": aat,
        "cn-token": getCookie("cn-token"),
      },
      credentials: useCredentials ? "include" : "omit",
      body: JSON.stringify(payload),
    });

    return handleResponse(res, json);
  } catch (e) {
    console.error("POST request failed:", e);
    throw e; // Re-throw to allow calling code to handle
  }
}

async function putApiCall(hook, payload = {}, json = true) {
  const res = await fetch(`${baseUrl}${hook}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "admin-access-token": aat,
      "cn-token": getCookie("cn-token"),
    },
    credentials: useCredentials ? "include" : "omit",
    body: JSON.stringify(payload),
  });

  return handleResponse(res, json);
}

export default new Vuex.Store({
  mutations: {
    // Your mutations here
  },
  actions: {
    async getApiCallAction(context, { hook, json = true }) {
      return getApiCall(hook, json);
    },
    async postApiCallAction(
      context,
      { hook, body = {}, json = true, url = baseUrl }
    ) {
      return postApiCall(hook, body, json, url);
    },
    async putApiCallAction(context, { hook, body = {}, json = true }) {
      return putApiCall(hook, body, json);
    },
  },
  modules: {},
});
